var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-row",
    [
      _c(
        "w-col",
        { attrs: { xs: "12", md: "6" } },
        [
          _c("w-date-picker", {
            attrs: { fancy: "", label: _vm.startLabel },
            model: {
              value: _vm.start,
              callback: function ($$v) {
                _vm.start = $$v
              },
              expression: "start",
            },
          }),
        ],
        1
      ),
      _c(
        "w-col",
        { attrs: { xs: "12", md: "6" } },
        [
          _c("w-date-picker", {
            attrs: { fancy: "", label: _vm.endLabel },
            model: {
              value: _vm.end,
              callback: function ($$v) {
                _vm.end = $$v
              },
              expression: "end",
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }